module.exports = __webpack_public_path__ + "img/combo1.4c06d6cd.png";